import React from 'react';
import {
  Card,
  Container,
  Row,
  Col,
  HeaderText,
  BodyText,
  TwoIconTextButton,
  EnvelopeIcon,
  ChevronRightIcon,
} from 'shared-portal-component';

interface EmailOnlyMethodSelectProps {
  onSelect: (method: 'email') => void;
  email: string;
}

/**
 * Bypass-org variant of the shared AuthMethodSelect: these organizations
 * have no usable phone numbers, so only the email method is offered.
 */
const EmailOnlyMethodSelect: React.FC<EmailOnlyMethodSelectProps> = ({ onSelect, email }) => (
  <Container fluid>
    <Card>
      <Row spacing="md">
        <Col size={12}>
          <HeaderText
            text="Choose your second authentication method"
            className="header-text-auth"
          />
          <BodyText
            text="Please select the method below and we will send a 6-digit code to the selected location."
            as="p"
            className="body-text-auth"
          />
        </Col>
      </Row>
      <Row spacing="md" className="gap-4">
        <Col size={12}>
          <TwoIconTextButton
            leftIcon={<EnvelopeIcon />}
            text={`We will send the code to your email address ${email}`}
            rightIcon={<ChevronRightIcon />}
            variant="outline"
            size="sm"
            className="w-full"
            onClick={() => {
              onSelect('email');
            }}
          />
        </Col>
      </Row>
    </Card>
  </Container>
);

export default EmailOnlyMethodSelect;
